import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Link } from '@hub/link';
import { Logo } from '@hub/logos';
import React, { useContext } from 'react';
import { LinkContext } from '../../../context';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
export const UniversalHeaderLogos = ({
  logo,
  mono,
  boxSize,
  sx,
  url = '/'
}) => {
  const RouterLink = useContext(LinkContext);
  return /*#__PURE__*/_jsx(Link, {
    as: props => /*#__PURE__*/_jsx(RouterLink, _objectSpread({
      to: url
    }, props)),
    href: url,
    sx: sx,
    onClick: () => trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, analyticsUtils.labels.createLogoLabel(logo)),
    children: /*#__PURE__*/_jsx(Logo, {
      variant: logo,
      mono: mono,
      boxSize: boxSize
    })
  });
};